@let visionAsset = vision$ | async;

@if (vm(); as vm) {
	@if (
		!(
			(vm.vsnFeeCollection?.globalOptIn === null && vm.vsnFeeCollection?.eligibleForVsn === false) ||
			vm.vsnFeeCollection?.globalOptIn === false ||
			vm.vsnFeeCollection?.eligibleForVsn === false
		)
	) {
		@let isDisabled =
			vm.vsnFeeCollection?.globalOptIn === null ||
			(!vm.vsnFeeCollection?.visionFeeDetail?.hasEnoughFunds && vm.vsnFeeCollection.enabled && !isLimitOrder());
		<div
			class="vision-optin-toggle"
			[ngClass]="{
				disabled: isDisabled,
				on: vm.vsnFeeCollection?.enabled
			}">
			<div class="left">
				<div class="symbol">
					<svg width="28" height="30" viewBox="0 0 28 30" fill="none" xmlns="http://www.w3.org/2000/svg">
						<g id="vsn">
							<path
								id="V"
								d="M12.0048 16.2629L12.0048 19.7872L0 26.6919L-1.90901e-07 22.3246L7.64362 18.0115L7.64362 17.9572L-5.72702e-07 13.5899L-7.64788e-07 9.19542L12.0048 16.2629Z"
								class="vsn-icon-path" />
							<path
								id="V_2"
								d="M12.0966 15.611L9.04456 13.8489L9.06732 0L12.8495 2.18367L12.7629 10.9598L12.8099 10.987L20.4139 6.55101L24.2196 8.74824L12.0966 15.611Z"
								class="vsn-icon-path" />
							<path
								id="V_3"
								d="M12.6335 16.0699L15.6855 14.3078L27.6675 21.252L23.8853 23.4356L16.3283 18.9725L16.2813 18.9997L16.3209 27.803L12.5153 30.0002L12.6335 16.0699Z"
								class="vsn-icon-path" />
						</g>
					</svg>

					<span>{{ visionAsset.getSymbol() }}</span>
				</div>
				<div class="description">
					<h3 class="heading"
						>{{ vm.texts.heading.prefix | translate }}
						<span class="discount">{{ vm.texts.heading.discount | percent }}</span>
						{{ vm.texts.heading.suffix | translate }}</h3
					>
					<p class="subheading">{{ vm.texts.subheading | translate: [visionAsset.getSymbol()] }}</p>
					<p class="disabled">
						@if (!vm.vsnFeeCollection?.globalOptIn || !vm.vsnFeeCollection?.visionFeeDetail) {
							{{ vm.texts.failed | translate: [visionAsset.getSymbol()] }}
						} @else if (!vm.vsnFeeCollection?.visionFeeDetail?.hasEnoughFunds) {
							{{ vm.texts.insufficient | translate: [visionAsset.getSymbol()] }}
						}
					</p>
				</div>
			</div>
			@if (!isDisabled) {
				@if (showToggle()) {
					<div class="right"
						><input
							type="checkbox"
							[formControl]="toggleCtrl"
							class="toggle-chkbox"
							[class.toggle-chkbox-on]="toggleCtrl.value"
					/></div>
				}
			}
		</div>
	}
}
